import type { SaturatedOilViscosityParameters } from "../../d";

export function saturatedOilViscosityCalculator(
  params: SaturatedOilViscosityParameters
): {
  saturatedOilViscosity: number;
} {
  // NOT IMPLEMENTED ACCORDING TO SPREADSHEET

  // const deadOilViscosity =
  //   params.deadOilViscosityOverride ||
  //   deadOilViscosityCalculator(params).deadOilViscosity;

  return {
    saturatedOilViscosity: 0
  };
}
